<template>
  <section :style="{ paddingTop: `${MENU_BAR_HEIGHT}px` }">
    <v-container>
      <v-row align="center">
        <v-col
          :lg="!!value.display_option ? 6 : 8"
          :xxl="!!value.display_option ? 6 : 8"
          class="pt-8 pt-md-16 pb-8"
          cols="12"
        >
          <h1
            v-if="value.title"
            class="text-h3 text-sm-h2 font-weight-regular mb-3"
            style="line-height: 118%"
          >
            <StyledText
              em-class="text-light-blue-darken-2 font-weight-medium"
              :value="value.title"
            />
          </h1>

          <p
            v-if="value.paragraph"
            class="text-body-1 text-sm-h6 font-weight-regular"
          >
            <StyledText :value="value.paragraph" />
          </p>

          <div v-if="value.ctas && value.ctas.length" class="mt-4">
            <CtaButton
              v-for="(cta, i) in value.ctas"
              :key="cta.id"
              :class="i < value.ctas.length - 1 ? 'mr-6' : ''"
              :secondary="i > 0"
              :value="cta.ctas_id"
              class="text-none my-3"
              rounded="pill"
            />
          </div>

          <v-breadcrumbs
            v-if="breadcrumbs"
            :items="breadcrumbs"
            divider="|"
            class="flex-wrap"
          >
            <template #title="{ item }">
              <v-icon v-if="item.href === '/'" :icon="mdiHome" size="20" />
              <span v-else class="text-h6 text-uppercase font-weight-regular">{{
                item.title
              }}</span>
            </template>
          </v-breadcrumbs>
        </v-col>

        <v-col
          v-if="
            value.display_option === 'contact-form' && value.contact_form_config
          "
          cols="12"
          lg="6"
        >
          <ContactFormCard :value="value.contact_form_config" />
        </v-col>

        <v-col
          v-else-if="value.display_option === 'statistics' && value.statistics"
          cols="12"
          lg="6"
          class="mx-auto d-flex flex-row"
        >
          <v-card
            class="pa-4 mb-8 mb-lg-0 mx-auto"
            rounded="xl"
            variant="outlined"
          >
            <v-container fluid>
              <v-row justify="center">
                <v-col v-for="(statistic, i) in value.statistics" :key="i">
                  <StatisticCard :value="statistic" variant="tonal" />
                </v-col>
              </v-row>

              <v-row>
                <v-col class="text-h6 text-center">
                  {{ value.statistics_footer }}
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>

        <v-col
          v-else-if="value.display_option === 'image' && imgResp.src"
          cols="12"
          lg="6"
        >
          <v-img
            :aspect-ratio="aspectRatio"
            :sizes="imgResp.sizes"
            :src="imgResp.src"
            :srcset="imgResp.srcset"
            alt="Image for the hero section"
            class="mb-8 ml-lg-8 mt-lg-8"
            cover
            max-height="520"
          />
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script setup>
import { computed, toRef } from 'vue'
import { MENU_BAR_HEIGHT } from '#root/lib/consts'
import { useImgResponsive } from '#root/lib/img'
import { mdiHome } from '@mdi/js'

const props = defineProps({
  value: {
    required: true,
    type: Object
  }
})

const aspectRatio = 1
const breadcrumbs = computed(() => {
  return props.value.nav_title
    ? [
        {
          title: 'Home',
          href: '/'
        },
        {
          title: props.value?.nav_title || 'Page'
        }
      ]
    : undefined
})
const imgResp = useImgResponsive(
  toRef(() => ({
    aspectRatio,
    image: props.value.image,
    sizes: {
      xs: '500px'
    },
    transformation: props.value.image_transformation
  }))
)
</script>
